import { useMutation } from '@tanstack/react-query';
import { useParticipantsPersonEventsApi } from 'services';

export const useConfirmAccount = () => {
  const { confirmAccount } = useParticipantsPersonEventsApi();

  return useMutation({ mutationFn: confirmAccount });
};
